import BusinessSettingsStore from './BusinessSettingsStore'

export default BusinessSettingsStore
